export const localization = {
    header : {
        actions: '', //replace the label 'actions' to empty string
    },
};

export function localizationBuilder(overrides = {}) {
    return {
        ...localization,
        ...overrides,
    };
}
